import { render, staticRenderFns } from "./new.badges.page.vue?vue&type=template&id=2faa832b&"
import script from "./new.badges.page.vue?vue&type=script&lang=js&"
export * from "./new.badges.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports